import { BankType, BrandType, DebtManager } from '../generated/graphql';
import { getImageUrl } from './imagesRoot';

const apexBanks = [ BankType.Occidente, BankType.Rappipay, BankType.BancoPopular ];
const bankImages: { [key: string]: string } = {
  [BankType.BancoDavivienda]: 'banklogos/davivienda.png',
  [BankType.Bbva]: 'banklogos/bbva.png',
  [BankType.Rappipay]: 'banklogos/rappipay.png',
  [BankType.RappiPrestamo]: 'banklogos/rappi-prestamo.png',
  [BankType.Pichincha]: 'banklogos/pichincha.png',
  CREDIORBE: 'banklogos/crediorbe.png',
  AVVILLAS: 'banklogos/avvillas.svg',
  DAVIPLATA: 'banklogos/daviplata.png',
  [BankType.BancoDeBogota]: 'banklogos/banco_bogota.png',
  [BankType.LuloBank]: 'banklogos/lulo.png',
  [BankType.MovistarMoney]: 'banklogos/apex.png',
  [BankType.Scotiabank]: 'banklogos/davibank.png',
  [BankType.NoBank]: '',
  [BankType.Occidente]: '',
  [BankType.Claro]: 'banklogos/claro.jpg',
  [BrandType.Pra]: '', // Todo: change to pra logo when we have it
};

const debtManagerImages: { [key in DebtManager]?: string } = {
  [DebtManager.Beta]: 'banklogos/cobranzas-beta.png',
  [DebtManager.Apex]: 'banklogos/apex.png',
  [DebtManager.Pra]: '',
};

export const getBankImage = (bank: string, isApexBrand?: boolean) => {
  if (isApexBrand && apexBanks.includes(bank as BankType)) {
    return getImageUrl('banklogos/apex.png');
  }
  /*
  if (isPraBrand) {
    return getImageUrl(''); // Todo: change to pra logo when we have it
  }
    */
  const image = bankImages[bank];
  if (!image) return undefined;
  return getImageUrl(image);
};

export const getDebtManagerImage = (debtManager: DebtManager) => {
  const image = debtManagerImages[debtManager] || bankImages[debtManager];
  if (!image) return undefined;
  return getImageUrl(image);
};
